import NumberFormatter from '../../../js/number_formatter'
import CustomCheckbox from '../../../js/components/customCheckbox/CustomCheckbox'
import messageResource from '../../../js/messageResource'
import $ from 'jquery'
import {PTOFormatter, SickFormatter} from '../../../js/util/BalanceFormatter'
import makeRpcCall from '../../../js/util/jquery_rpc'
import {getLocalStorage} from '../../../js/util/LocalStorage'


const AP_PAST_LEAVES_CALENDAR_COMMENTS_SHOWN = 'apPastLeavesCalendarCommentsShown'

export function LeaveTimeDetailsTable(){}

LeaveTimeDetailsTable.prototype.init = function(leaveTimeDetailsSetting, nameService){
    var self = this;

    this.daysFormatter =
            new NumberFormatter( SystemSettings.decimalSeparator, SystemSettings.digitGroupingSymbol, 2, true, '', 'd' );
    this.hoursFormatter =
            new NumberFormatter( SystemSettings.decimalSeparator, SystemSettings.digitGroupingSymbol, 2, true, '', 'h' );

    this.initSortMap(leaveTimeDetailsSetting);
    this.nameService = nameService;
    $( "table.requests > thead .sortButton.leaveType" ).click(function(){self.onChangeCallback(self.sortMap.leaveType);});
    $( "table.requests > thead .sortButton.period" ).click(function(){ self.onChangeCallback(self.sortMap.period)});
    $( "table.requests > thead .sortButton.timeRequested" ).click(function(){self.onChangeCallback(self.sortMap.timeRequested);});
    $( "table.requests > thead .sortButton.status" ).click(function(){self.onChangeCallback(self.sortMap.status);});

    this.leaveBalancesFilter = new LeaveBalancesFilter().init(
        $(".leaveBalancesFilterContainer")[0],
        function () {
            self.onChangeCallback(false);
        },
        {value: leaveTimeDetailsSetting.leaveBalancesFilter}
    );

    this.$showCommentsCheckbox = $('.showCommentsCheckbox')
    const showCommentsFromLocalStorage = this.getCommentsCheckboxStateFromLocalStorage()
    const showComments = showCommentsFromLocalStorage !== null ? showCommentsFromLocalStorage : true
    $('#leaveTimeTable').toggleClass('hideComments', !showComments)
    this.showCommentsCheckbox = new CustomCheckbox({
        label: messageResource.getMessage('common.show_comments'),
        checked: showComments,
        onChange: this.onCommentsCheckboxChanged
    }).init(this.$showCommentsCheckbox)

    this.balancesColumnStrategy = null;
    this.isPTO = null;
    this.isSick = null;

    this.initSliderButton();
    return this;
};

LeaveTimeDetailsTable.prototype.onCommentsCheckboxChanged = function({checked}) {
    getLocalStorage().setItem(AP_PAST_LEAVES_CALENDAR_COMMENTS_SHOWN, checked)
    $('#leaveTimeTable').toggleClass('hideComments', !checked)
}

LeaveTimeDetailsTable.prototype.getCommentsCheckboxStateFromLocalStorage = function() {
    return getLocalStorage().getItem(AP_PAST_LEAVES_CALENDAR_COMMENTS_SHOWN)
}

LeaveTimeDetailsTable.prototype.isCommentsShown = function() {
    return this.showCommentsCheckbox.isChecked()
}

LeaveTimeDetailsTable.prototype.getBalanceTypeFilterValue = function()
{
    return this.balancesColumnStrategy.isBalanceFilterActive() ? this.leaveBalancesFilter.getValue() : LeaveBalanceFilter.ALL;
};

 LeaveTimeDetailsTable.prototype.initSortMap = function(leaveTimeDetailsSetting) {
     var self = this;
     // inner sort always return leave sorted by asc, if they are equal sorted by period by asc.
     function innerSort(a, b)
     {
         var leaveTypeAPosition = LEAVE_TYPES[a.leaveTypeId].position;
         var leaveTypeBPosition = LEAVE_TYPES[b.leaveTypeId].position;
         var firstDateA = a.firstDate.parseJSONDate();
         var firstDateB = b.firstDate.parseJSONDate();
         return (leaveTypeAPosition == leaveTypeBPosition) ?
                ((firstDateA.getTime() < firstDateB.getTime()) ? -1 : 1) :
                ((leaveTypeAPosition > leaveTypeBPosition) ? 1 : -1);

     }

     function sortOnLeave(a, b)
     {
         var order = self.isAscending ? 1 : -1;
         var leaveTypeAPosition = LEAVE_TYPES[a.leaveTypeId].position;
         var leaveTypeBPosition = LEAVE_TYPES[b.leaveTypeId].position;
         return (leaveTypeAPosition == leaveTypeBPosition) ?
                innerSort(a, b) :
                (leaveTypeAPosition > leaveTypeBPosition) ? order : -order;
     }

     function sortOnPeriod(a, b)
     {
         var order = self.isAscending ? 1 : -1;
         var firstDateA = a.firstDate.parseJSONDate();
         var firstDateB = b.firstDate.parseJSONDate();
         return (firstDateA.getTime() < firstDateB.getTime()) ? -order : order;
     }

     function sortOnTimeRequested(a, b)
     {
         var order = self.isAscending ? 1 : -1;
         var requestedA = a.leaveTimeTotal.hours;
         var requestedB = b.leaveTimeTotal.hours;
         return (requestedA == requestedB) ?
                innerSort(a, b) :
                (requestedA < requestedB) ? -order : order;
     }

     function sortOnStatus(a, b)
     {
         var order = self.isAscending ? 1 : -1;
         var statusDateA = a.statusDate.parseJSONDate();
         var statusDateB = b.statusDate.parseJSONDate();
         return (statusDateA.getTime() == statusDateB.getTime()) ?
                innerSort(a, b) :
                (statusDateA.getTime() < statusDateB.getTime()) ? -order : order;
     }

     this.sortMap = {
         period: {name: "period", func: sortOnPeriod},
         leaveType: {name: "leaveType", func: sortOnLeave},
         timeRequested: {name: "timeRequested", func: sortOnTimeRequested},
         status: {name: "status", func: sortOnStatus}
     };

     this.isAscending =  leaveTimeDetailsSetting.asc;
     this.sortBy = leaveTimeDetailsSetting.nameOrder;
 };

 LeaveTimeDetailsTable.prototype.initSliderButton = function(){
     var self = this;
     this.sliderButton = $(".sliderButton");
     this.sliderButton.click(function(){self.sliderButtonClick()});

     var isOpenTable = $.cookie("actiPLANS-leaveDetailsTableIsOpen");
     if (isOpenTable == "false"){
         this.sliderButton.toggleClass("expand");
         $("#leaveTimeTable" ).css('display', 'none');
         this.$showCommentsCheckbox.hide()
     }
 };


 LeaveTimeDetailsTable.prototype.onChangeCallback = function(sortColumn){
     if ( sortColumn )
     {
         if( this.sortBy == sortColumn.name )
         {
             this.isAscending = !this.isAscending;
         }
         else
         {
             this.sortBy = sortColumn.name;
             this.isAscending = sortColumn.name != this.sortMap.period.name;
         }
     }

     var self = this;
     makeRpcCall ( self.nameService +'.saveLeaveTimeDetailsSetting', [{nameOrder: self.sortBy, asc: self.isAscending, leaveBalancesFilter: self.getBalanceTypeFilterValue()}],
                   function(){return false});

     this.updateData(this.requestRecords, this.isPTO, this.isSick);
 };

 LeaveTimeDetailsTable.prototype.updateRow = function (row, rowData){

     var leaveType = LEAVE_TYPES[rowData.leaveTypeId];

     row.toggleClass("archivedLeaveTime", !leaveType.active);
     row.find( "td.period").html( this.formatRequestPeriod( rowData ) );
     row.find( "td.leaveType img" ).attr( "src", leaveType.getIconPath() );
     row.find( "td.leaveType .for-print-only img" ).attr( "src", leaveType.getPrintIconPath() );
     row.find( "td.leaveType .leaveTypeName" ).text( leaveType.name );
     row.find( "td.timeRequested" ).find(".timeRequestedInDays").text( this.daysFormatter.format( rowData.leaveTimeTotal.days ) );
     row.find( "td.timeRequested" ).find(".timeRequestedInHours").text( this.hoursFormatter.format( rowData.leaveTimeTotal.hours ) );

     var commentTextEl = row.find('td.comment .text')
     if (rowData.comment == null) {
         row.find('td.comment .text').addClass('noComment')
         commentTextEl.text('--')
     } else {
         commentTextEl.text(rowData.comment)
         commentTextEl.attr('title', rowData.comment)
     }

     var statusCell = row.find( "td.status" );
     statusCell.find( ".statusText" ).text(this.getStatusText(rowData));
     statusCell.find( ".when" ).text(this.getStatusDateText(rowData));
     statusCell.find( ".byWhom" ).text(this.getStatusApproverText(rowData));

     if( rowData.balanceData && rowData.balanceData.balanceChangeData )
     {
         var self = this;
         switch ( leaveType.balanceType )
         {
             case BalanceType.PTO:
                 if ( SystemSettings.apPtoBalanceCalculationEnabled )
                     this._addDataToLeaveBalanceCell( row, rowData.balanceData.balanceChangeData,
                                                      function(value) { return self.ptoFormatter.format(value); },
                                                      function(value) { return self.ptoFormatter.isNegativePTO(value) } );
                 else
                     this._paintAsNotApplicable( row );
                 break;
             case BalanceType.SICK:
                 if ( SystemSettings.apSickBalanceCalculationEnabled )
                 {
                     this._addDataToLeaveBalanceCell( row, rowData.balanceData.balanceChangeData,
                                                      function(value) { return self.sickFormatter.format(value); },
                                                      function(value) { return self.sickFormatter.isNegativePTO(value) } );
                     row.find( "td.balance.before" ).append( $( "<span class='sickSpan'>" + "Sick Days Balance" + "</span>" ) ).addClass( "sickBalanceCell" );
                     row.find( "td.balance.after" ).addClass( "sickBalanceCell" );
                 }
                 else
                 {
                     this._paintAsNotApplicable( row );
                 }
                 break;
         }
     }
     else
     {
         this._paintAsNotApplicable( row );
     }
 };

LeaveTimeDetailsTable.prototype._paintAsNotApplicable = function( row )
{
    row.find( "td.balance.before" ).text( "\u2013" ).addClass( "na" );
    row.find( "td.balance.after" ).text( "\u2013" ).addClass( "na" );
};

LeaveTimeDetailsTable.prototype._addDataToLeaveBalanceCell = function(row, balanceChangeData, formatValueFn, isNegativeFn){
    var start = balanceChangeData.startBalance;
    var end = balanceChangeData.endBalance;

    var hasStartValue = start != null;
    var hasEndValue = end != null;

    var beforeEl = row.find( "td.balance.before" ).text( hasStartValue ? formatValueFn( start ) : "\u2013" ).removeClass( "na", !hasStartValue );

    if( hasStartValue )
        beforeEl.toggleClass( "negative", isNegativeFn(start));
    else
        beforeEl.addClass( "beforeNA" );

    row.find( "td.balance.after" ).text( hasEndValue ? formatValueFn( end ) : "\u2013" ).toggleClass( "negative", hasEndValue && isNegativeFn(end) )
            .removeClass( "na", !hasEndValue );
};

LeaveTimeDetailsTable.prototype.getStatusText = function(request){
    return messageResource.getMessage('actiplans.request_status.approved');
};

LeaveTimeDetailsTable.prototype.getStatusDateText = function(request){
    return request.statusDate.parseJSONDate().format( "M d, Y" );
};

LeaveTimeDetailsTable.prototype.getStatusApproverText = function(request){
    if (request.approverInfo)
     return messageResource.getMessage( 'actiplans.request_status.by_user', [UserNameFormat.formatFML(request.approverInfo.firstName, request.approverInfo.lastName, request.approverInfo.middleInitial )] );
    
    return messageResource.getMessage('actiplans.request_status.automatic_approval');
};

 LeaveTimeDetailsTable.prototype.updateSortingIndicators = function(){
     var sortIndicator = $( "table.requests > thead .sortHeader" );
     sortIndicator.removeClass( "ascending" );
     sortIndicator.removeClass( "descending" );
     $( "table.requests > thead ." + this.sortBy)
             .addClass( this.isAscending ? "ascending" : "descending" );
 };

 LeaveTimeDetailsTable.prototype.formatRequestPeriod = function (request){
     var firstDate = request.firstDate.parseJSONDate();
     var lastDate = request.lastDate.parseJSONDate();

     if( firstDate.isSameDate( lastDate ) )
         return firstDate.format( "M d, Y" );
     else
         return firstDate.format( "M d" ) + " &ndash; " + lastDate.format( "M d, Y" );
 };

LeaveTimeDetailsTable.prototype.initAndUpdate = function(requestRecords, ptoHoursPerDay, isPTO, isSick){
    this.ptoFormatter = new PTOFormatter().init( ptoHoursPerDay );
    this.sickFormatter = new SickFormatter().init( ptoHoursPerDay );
    this.updateData(requestRecords, isPTO, isSick);
};

LeaveTimeDetailsTable.prototype.updateData = function(requestRecords, isPTO, isSick){
     $( "table.requests > tbody.actualContent tr" ).remove();

     this.isPTO = isPTO;
     this.isSick = isSick;
     this.balancesColumnStrategy = this.getBalanceColumnStrategy( isPTO, isSick );

     var self = this;
     this.requestRecords = requestRecords;
     var records = $.grep( this.requestRecords, function(value){ return self.filterRowByBalanceType(value); } );

     if( records.length == 0  )
         $( "table.requests tbody.templates tr.emptyRequest" ).clone().appendTo( "table.requests tbody.actualContent" );

     else{
         records.sort( self.sortMap[self.sortBy].func );
         this.updateSortingIndicators();

         var even = false;

         $.each( records, function ()
         {
             var newRow = $( "table.requests tbody.templates tr.request" ).clone().appendTo( "table.requests tbody.actualContent" );
             self.updateRow( newRow, this );
             if( even )
                 newRow.addClass( 'even' );
             else
                 newRow.addClass( 'odd' );
             even = !even;
         } );
     }
 };

LeaveTimeDetailsTable.prototype.filterRowByBalanceType = function( rowData )
{
    if ( !this.balancesColumnStrategy.isBalancesColumnEnabled() || !this.balancesColumnStrategy.isBalanceFilterActive() )
    {
        return true;
    }
    if ( this.balancesColumnStrategy.isBalanceFilterActive() ){
        var balanceType = LEAVE_TYPES[rowData.leaveTypeId].balanceType;
        switch ( this.leaveBalancesFilter.getValue() )
        {
            case LeaveBalanceFilter.PTO:
                return balanceType == BalanceType.PTO && rowData.balanceData && rowData.balanceData.balanceChangeData;
            case LeaveBalanceFilter.SICK:
                return balanceType == BalanceType.SICK && rowData.balanceData && rowData.balanceData.balanceChangeData;
        }
    }
    return true;
};

LeaveTimeDetailsTable.prototype.sliderButtonClick = function()
{
    this.sliderButton.toggleClass("expand");

    var hasClassExpand =  !this.sliderButton.hasClass("expand");
    $.cookie("actiPLANS-leaveDetailsTableIsOpen", hasClassExpand);
    if (hasClassExpand){
        $("html, body").animate({ scrollTop:  $(document).scrollTop()+200}, "fast");
    }
    $("#leaveTimeTable").slideToggle( "fast" );
    this.$showCommentsCheckbox.toggle(hasClassExpand)
};

LeaveTimeDetailsTable.prototype.getBalanceColumnStrategy = function( isPTO, isSick )
{
    if (isPTO && isSick)
    {
        return new LeaveTimeDetailsBalanceColumnWithFilterStrategy().init();
    }
    else if ( isPTO )
    {
        return new LeaveTimeDetailsPtoBalanceColumnStrategy().init();
    }
    else if ( isSick )
    {
        return new LeaveTimeDetailsSickBalanceColumnStrategy().init();
    }
    return new NoLeaveTimeDetailsBalanceColumnStrategy().init();
};




//-----------------------------------------------------------------------------------

function LeaveTimeDetailsBalanceColumnStrategy(){}

LeaveTimeDetailsBalanceColumnStrategy.prototype.init = function()
{
    return this;
};

LeaveTimeDetailsBalanceColumnStrategy.prototype.isBalancesColumnEnabled = function()
{
    // abstract
};

LeaveTimeDetailsBalanceColumnStrategy.prototype.isBalanceFilterActive = function()
{
    // abstract
};


//-----------------------------------------------------------------------------------


function NoLeaveTimeDetailsBalanceColumnStrategy(){}

NoLeaveTimeDetailsBalanceColumnStrategy.prototype = new LeaveTimeDetailsBalanceColumnStrategy();

NoLeaveTimeDetailsBalanceColumnStrategy.prototype.init = function()
{
    $( ".leaveTimeHistoryTable" ).addClass( "withoutBalancesColumn withoutBalancesFilter" );
    return this;
};

NoLeaveTimeDetailsBalanceColumnStrategy.prototype.isBalancesColumnEnabled = function()
{
    return false;
};

NoLeaveTimeDetailsBalanceColumnStrategy.prototype.isBalanceFilterActive = function()
{
    return false;
};


//-----------------------------------------------------------------------------------


function LeaveTimeDetailsBalanceColumnWithFilterStrategy(){}

LeaveTimeDetailsBalanceColumnWithFilterStrategy.prototype = new LeaveTimeDetailsBalanceColumnStrategy();

LeaveTimeDetailsBalanceColumnWithFilterStrategy.prototype.init = function()
{
    $( ".leaveTimeHistoryTable" ).removeClass( "withoutBalancesFilter withoutBalancesColumn");
    return this;
};

LeaveTimeDetailsBalanceColumnWithFilterStrategy.prototype.isBalancesColumnEnabled = function()
{
    return true;
};

LeaveTimeDetailsBalanceColumnWithFilterStrategy.prototype.isBalanceFilterActive = function()
{
    return true;
};


//-----------------------------------------------------------------------------------


function LeaveTimeDetailsPtoBalanceColumnStrategy(){}

LeaveTimeDetailsPtoBalanceColumnStrategy.prototype = new LeaveTimeDetailsBalanceColumnStrategy();

LeaveTimeDetailsPtoBalanceColumnStrategy.prototype.init = function()
{
    $( ".leaveTimeHistoryTable" ).addClass( "withoutBalancesFilter").removeClass( "withoutBalancesColumn");
    $(".leaveTimeHistoryTable table.requests thead td.balance.combined .withoutBalancesFilterHeaderDiv").text(messageResource.getMessage("leave_balances.header.pto") + "\u00a0")
        .append($("<span class='withoutBalancesFilterSpan'>" + messageResource.getMessage("leave_balances.header.smaller") + "</span>"));
    return this;
};

LeaveTimeDetailsPtoBalanceColumnStrategy.prototype.isBalancesColumnEnabled = function()
{
    return true;
};

LeaveTimeDetailsPtoBalanceColumnStrategy.prototype.isBalanceFilterActive = function()
{
    return false;
};


//-----------------------------------------------------------------------------------


function LeaveTimeDetailsSickBalanceColumnStrategy(){}

LeaveTimeDetailsSickBalanceColumnStrategy.prototype = new LeaveTimeDetailsBalanceColumnStrategy();

LeaveTimeDetailsSickBalanceColumnStrategy.prototype.init = function()
{
    $( ".leaveTimeHistoryTable" ).addClass( "withoutBalancesFilter").removeClass( "withoutBalancesColumn");
    $(".leaveTimeHistoryTable table.requests thead td.balance.combined .withoutBalancesFilterHeaderDiv").text(messageResource.getMessage("leave_balances.header.sick") + "\u00a0")
        .append($("<span class='withoutBalancesFilterSpan'>" + messageResource.getMessage("leave_balances.header.smaller") + "</span>"));
    return this;
};

LeaveTimeDetailsSickBalanceColumnStrategy.prototype.isBalancesColumnEnabled = function()
{
    return true;
};

LeaveTimeDetailsSickBalanceColumnStrategy.prototype.isBalanceFilterActive = function()
{
    return false;
};



// WEBPACK FOOTER //
// ./web/actiplans/js/administration/leave_time_details_table.js